import utils from './wallUtils';

// LOGINWALL JS FROM LONDO
const CALLBACK_MAX_WAIT = 3000;
const CALLBACK_EVENT_TIMEOUT = 2000;
const CALLBACK_DELAY = 300;

const trackLoginPaywallEvent = (action, cb) => {
  if (window.LorienDispatch) {
    const payload = {
      structuredEvent: {
        eventCategory: 'Funnel Tracking',
        eventAction: action,
      },
    };
    if (typeof cb === 'function') {
      // Never wait longer than CALLBACK_MAX_WAIT
      setTimeout(() => {
        cb();
      }, CALLBACK_MAX_WAIT);
      payload.eventTimeout = CALLBACK_EVENT_TIMEOUT;
      payload.eventCallback = cb;
    }
    window.LorienDispatch.dispatchEvent('loginWallEvent', payload);
  } else if (typeof cb === 'function') {
    cb();
  }
};

const trackLoginWallClick = (elem, action) => {
  elem.addEventListener('click', (event) => {
    event.preventDefault();
    const url = event.currentTarget.href;
    const callbackToRedirectUser = () => {
      setTimeout(() => {
        window.location.href = url;
      }, CALLBACK_DELAY);
    };
    trackLoginPaywallEvent(action, callbackToRedirectUser);
  });
};

const loginRequiredPaywall = (options) => {
  const trxId = utils.generateTransactionId();
  const pwCreateLink = document.querySelector('.js-create-account-link');
  const pwLoginLink = document.querySelector('.js-login-link');
  const createLinkUrlParams = utils.getLoginwallUrlParams(options.channel, 'login-paywall-signup', trxId);
  if (pwCreateLink.href.includes('luotunnus')) {
    pwCreateLink.href += createLinkUrlParams;
  } else {
    const newParams = createLinkUrlParams.replace('next=', `content_url=${encodeURIComponent(window.location.origin)}`);
    const hasParams = pwCreateLink.href.includes('?');
    pwCreateLink.href += hasParams ? newParams : newParams.replace('&', '?');
  }
  const loginLinkUrl = pwLoginLink.href + utils.getLoginwallUrlParams(options.channel, 'login-paywall-logins', trxId);
  pwLoginLink.href = loginLinkUrl;

  window.dataLayer.push({
    logintxid: trxId,
  });

  trackLoginPaywallEvent('Login Walled Page Landed');
  trackLoginWallClick(pwCreateLink, 'Signup link clicked');
  trackLoginWallClick(pwLoginLink, 'Login link clicked');
};

export default loginRequiredPaywall;
